import { render } from "./FooterPIT.vue?vue&type=template&id=f4eda7d4&scoped=true"
import script from "./FooterPIT.vue?vue&type=script&lang=js"
export * from "./FooterPIT.vue?vue&type=script&lang=js"

import "./FooterPIT.vue?vue&type=style&index=0&id=f4eda7d4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src546786139/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4eda7d4"]])

export default __exports__